var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sb-paytable-win-lines"},[_c('img',{attrs:{"src":'./assets/common/paytable/win_lines.png',"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }